import { ToolbarButton } from '../ToolbarButton';
import React, { useCallback } from 'react';
import { Typography } from 'antd';
import clsx from 'clsx';

const { Text } = Typography;

export const CommandButton = ({
  children,
  label,
  labelOptions,
  active = false,
  enabled,
  onClick,
  onChange,
  icon,
  ...rest
}) => {
  const handleChange = useCallback(
    (e, value) => {
      onClick?.(e);
      onChange?.(e, value);
    },
    [onClick, onChange]
  );

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
  }, []);

  return (
    <ToolbarButton
      className={clsx({ toolbar__button: true, active: active, disabled: !enabled })}
      onClick={handleChange}
      onMouseDown={handleMouseDown}
      icon={icon}
      type="text"
      {...rest}
    >
      {label && (
        <Text className="command__button-text" {...(labelOptions || {})}>
          {label}
        </Text>
      )}
      {children}
    </ToolbarButton>
  );
};
